import "p5/lib/addons/p5.sound";
import p5 from "p5";


export default function sketch(p) {

  function setGradient(x, y, w, h, c1, c2, axis) {
    p.noFill();
    if (axis == "Y") {  // Top to bottom gradient
      for (let i = y; i <= y+h; i++) {
        var inter = p.map(i, y, y+h, 0, 1);
        var c = p.lerpColor(c1, c2, inter);
        p.stroke(c);
        p.line(x, i, x+w, i);
      }
    }  
    else if (axis == "X") {  // Left to right gradient
      for (let j = x; j <= x+w; j++) {
        var inter2 = p.map(j, x, x+w, 0, 1);
        var d = p.lerpColor(c1, c2, inter2);
        p.stroke(d);
        p.line(j, y, j, y+h);
      }
    }
  }
  let canvas;
  let song
  let fft
  let ismute = false
  let duration
  let current_time
  let left_time
  let song_name
  let playPercent
  let songLoaded = false
  let w;
  let amp;
  p.setup = () => {
    amp = new p5.Amplitude();
    fft = new p5.FFT()
    w = p.width / 16
    song = p.loadSound('https://emo-speech.web.app/help-safe-fearful-20190712141232.wav', () => {
      console.log('loaded')
      songLoaded = true
      song.play()
})

  };

  p.draw = () => {
    canvas = p.createCanvas(300, 110);
    p.noStroke();
    var spectrum = fft.analyze()
    p.noStroke()
    let c  = p.color('#d6ff08');
    console.log('reload fadsf')
    p.fill(c) // spectrum is green
    for (var i = 0; i < spectrum.length; i += 3) {
      var amp = spectrum[i];
      var y = p.map(amp, 0, 255, p.height, 0)
      p.rect(i * w, y, w, p.height - y)
      p.fill(c);
    }

  };

  p.myCustomRedrawAccordingToNewPropsHandler = newProps => {
    if (canvas)
      //Make sure the canvas has been created
      p.fill(newProps.color);
  };
}
